import type { FaireProductEntity } from "../../entity_types/product";

export const p_79pfhib64c: FaireProductEntity = {
  token: "p_79pfhib64c",
  type: "product",
  name: "Sled Dogs holiday greeting card",
  brandToken: "b_4cu4uycf",
  brandName: "Red Cap Cards",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/98c1b9c303c93e893ff92eaeaf60abffb1f48aee11b522512f61028ebe0bde29/1559330247.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/29edcf47cbb0b69f086a8dd2f149de966c91793c26b75ee5d7af67ae5fd541fc.jpeg",
  ],
  priceDollars: 2.75,
  description:
    "• Blank inside.\n• 100lb heavyweight card stock.\n• Offset printed.\n• 4.25 x 5.5 inches.\n• Illustrated by Dylan Mierzwinski.\n• Printed by Red Cap Cards in Los Angeles, California, USA, on recycled paper.\n• Available as both single cards and pre-packaged boxed cards.\n• Each single card comes with an envelope and a cellophane sleeve.\n• Boxed sets are 8 cards with envelopes and are to be sold as packaged, not to be re-sold as individual cards.",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:21.818Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
